import { createClient } from '@supabase/supabase-js'
import type { Database } from './database.types'

const url = (import.meta.env.VITE_SUPABASE_URL ?? '').trim()

// Supabase объявил anon-ключи устаревшими в пользу publishable. Предпочитаем новое
// имя переменной, но старое продолжаем понимать — значение в них одинаковое.
const key = (
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ??
  import.meta.env.VITE_SUPABASE_ANON_KEY ??
  ''
).trim()

/**
 * Заполнен ли .env. Проверяем до создания клиента: без этого приложение падало бы
 * на импорте (белый экран), а не показывало понятную страницу настройки.
 */
export const isSupabaseConfigured = /^https?:\/\//.test(url) && key.length > 0

// Пустые строки в createClient бросают исключение, поэтому в ненастроенном режиме
// подставляем адрес локального стека. Клиент в этом режиме не используется:
// роутер уводит на /setup.
export const supabase = createClient<Database>(
  isSupabaseConfigured ? url : 'http://127.0.0.1:54321',
  isSupabaseConfigured ? key : 'not-configured',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: isSupabaseConfigured,
      detectSessionInUrl: false,
    },
  },
)

// Адрес функций настраивается отдельно от адреса проекта: при переезде
// рантайма на другую площадку он меняется, а база может остаться прежней.
// Значение по умолчанию — прежняя склейка, поэтому поведение не меняется
// ни на шаг, пока переменную не задали.
/** Базовый URL Edge Functions проекта. */
export const functionsUrl = (
  import.meta.env.VITE_FUNCTIONS_URL ?? `${url.replace(/\/$/, '')}/functions/v1`
).replace(/\/$/, '')
